import axios from 'axios';
import { leaveFamilyAction } from './LeaveFamilySlice';

const leaveFamily = (token) => {
  return async (dispatch) => {
    const fetchData = async () => {
      const url = `${process.env.REACT_APP_DEV_URI}/user/family/leave`;
      const headers = { Authorization: `Bearer ${token}` };
      const response = await axios.delete(url, { headers });
      return response;
    };
    try {
      const result = await fetchData();
      dispatch(leaveFamilyAction.leaveFamilySuccess(result.data));
    } catch (e) {
      dispatch(leaveFamilyAction.leaveFamilyFailure(e.response?.data ?? e.message));
    }
  };
};

export default leaveFamily;